import Skeleton from 'components/LoadingSkeleton';

const ClinicLoadingSkeleton = () => {
  return (
    <div className="flex flex-col gap-5 px-6 pb-4">
      {[...Array(3)].map((_, index) => (
        <div className="flex min-w-0 gap-4 rounded-2xl border border-transparent p-5" key={index}>
          {/* Profile image skeleton */}
          <Skeleton className="aspect-square h-auto w-full max-w-[12.5rem] rounded-xl" />

          <div className="flex flex-1 flex-col">
            {/* Date/time and price */}
            <div className="flex justify-between">
              <Skeleton width={150} height={16} />
              <Skeleton width={50} height={16} />
            </div>

            {/* Title */}
            <div className="mt-ds-sm">
              <Skeleton width="70%" height={24} />
            </div>

            {/* Description - 3 lines */}
            <div className="mt-ds-sm">
              <Skeleton count={3} height={16} />
            </div>

            {/* Location */}
            <div className="mt-2 flex items-center gap-4">
              <Skeleton width={200} height={16} />
              <Skeleton width={80} height={16} />
            </div>

            {/* Coach information */}
            <div className="mt-ds-sm">
              <Skeleton width={140} height={16} />
            </div>

            {/* Participants and join button */}
            <div className="mt-auto flex min-w-0 items-center justify-between">
              <div className="flex items-center gap-ds-sm">
                <Skeleton width={100} height={16} />
                <div className="flex">
                  {/* Participant avatars - show 3 */}
                  {[...Array(3)].map((_, index) => (
                    <div key={index} className={`relative ${index > 0 ? '-left-2' : ''}`}>
                      <Skeleton circle width={24} height={24} />
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex min-w-fit items-center gap-ds-sm">
                <Skeleton width={80} height={16} />
                <Skeleton width={100} height={32} borderRadius={8} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClinicLoadingSkeleton;
